import React from 'react';
import './styles.scss';
import { useTranslation } from 'react-i18next';

interface SmallTableProps {
    itemTitle: string;
    original: string;
    cancel: string;
    adjusted: string;
    current: string;
    showHeaders?: boolean; // Prop para activar los headers
}

const SmallTable: React.FC<SmallTableProps> = ({ itemTitle, original, cancel, adjusted, current, showHeaders }) => {
    const { t } = useTranslation();
    return (
        <div className='c-content'>
            {showHeaders && (
                <div data-testid="c-table headers" className='c-table headers'>
                    <p className='header-item'></p>
                    <p className='header-original'><b>{t('one_pager_report.original')}</b></p>
                    <p className='header-canceled'><b>{t('one_pager_report.canceled')}</b></p>
                    <p className='header-adjusted'><b>{t('one_pager_report.adjusted')}</b></p>
                    <p className='header-current'><b>{t('one_pager_report.current')}</b></p>
                </div>
            )}
            <div data-testid="c-table-rows" className='c-table-rows'>
                <p className='item'><b>{itemTitle}</b></p>
                <p className='original'>{original}</p>
                <p className='cancel'>{cancel}</p>
                <p className='adjusted'>{adjusted}</p>
                <p className='current'>{current}</p>
            </div>
        </div>
    );
}

export default SmallTable;
